import _ from "lodash";
import ACTIONS from "../actions/TestcacheActions";

const initialState = {

    testcacheObject: {
        addressline1: "",
        addressline2: "",
        addressline3: "",
        administrativearea: "",
        completename: "",
        countrycode: "",
        data_source_type: "",
        dob: "",
        givenfullname: "",
        housenumber: "",
        id: "",
        locality: "",
        modified_date: "",
        nationalid: "",
        phone: "",
        postalcode: "",
        surname_first: "",
        thoroughfare: "",
    },
    addTestcacheModalOpen: false,
    editTestcacheModalOpen: false,
    deleteTestcacheWarning: false,
    showPostmanRequest: false,
    testcacheIDForDelete: null,
    postmanObject: {
        "options": "",
        "credentials": {
            "tenant": "",
            "username": "",
            "password": ""
        },
        "address": {
            "addressLine1": "",
            "addressLine2": "",
            "houseNumber": "",
            "houseNumberAddition":"",
            "thoroughfare": "",
            "locality": "",
            "postalCode": "",
            "province": "",
            "countryCode": ""
        },
        "identity": {
            "completename": "",
            "givenfullname": "",
            "surname_first": "",
            "nationalid": "",
            "dob": ""
        },
        "phone": {
            "phone_number": ""
        },
        "email": {
            "full_email_address": ""
        }
    }
}

const addEditTestcacheReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.TestcacheActionTypes.TOGGLE_ADD_TESTCACHE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.addTestcacheModalOpen = !newState.addTestcacheModalOpen;
            // reset the form to placeholder values
            if (!newState.addTestcacheModalOpen) {
                newState.testcacheObject = initialState.testcacheObject;
                newState.postmanObject = initialState.postmanObject;
            }

            return newState
        }

        case ACTIONS.TestcacheActionTypes.TOGGLE_EDIT_TESTCACHE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editTestcacheModalOpen = !newState.editTestcacheModalOpen;
            // reset the form to placeholder values
            if (!newState.editTestcacheModalOpen) {
                newState.testcacheObject = initialState.testcacheObject;
                newState.postmanObject = initialState.postmanObject;
            }

            return newState
        }

        case ACTIONS.TestcacheActionTypes.OPEN_EDIT_TESTCACHE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.testcacheObject = action.payload;
            newState.editTestcacheModalOpen = !newState.editTestcacheModalOpen;

            newState.postmanObject.address.addressLine1 = newState.testcacheObject.addressline1;
            newState.postmanObject.address.addressLine2 = newState.testcacheObject.addressline2;
            newState.postmanObject.address.addressLine3 = newState.testcacheObject.addressline3;
            newState.postmanObject.address.houseNumberAddition = newState.testcacheObject.housenumber;
            newState.postmanObject.address.thoroughfare = newState.testcacheObject.thoroughfare;
            newState.postmanObject.address.locality = newState.testcacheObject.locality;
            newState.postmanObject.address.postalCode = newState.testcacheObject.postalcode;
            newState.postmanObject.address.countryCode = newState.testcacheObject.countrycode;
            newState.postmanObject.identity.completename = newState.testcacheObject.completename;
            newState.postmanObject.identity.givenfullname = newState.testcacheObject.givenfullname;
            newState.postmanObject.identity.surname_first = newState.testcacheObject.surname_first;
            newState.postmanObject.identity.dob = newState.testcacheObject.dob;
            newState.postmanObject.identity.nationalid = newState.testcacheObject.nationalid;
            newState.postmanObject.phone.phone_number = newState.testcacheObject.phone;

            return newState
        }

        case ACTIONS.TestcacheActionTypes.SETTING_TESTCACHE_FORM_OBJECT_VALUE: {
            let newState = _.cloneDeep(state);
            newState.testcacheObject[action.payload.name] = action.payload.value;
            return newState
        }

        case ACTIONS.TestcacheActionTypes.SET_DATE_OF_BIRTH: {
            let newState = _.cloneDeep(state);
            newState.testcacheObject.dob = action.payload.day;
            return newState;
        }

        case ACTIONS.TestcacheActionTypes.SET_COUNTRY: {
            let newState = _.cloneDeep(state);
            if ( action.payload.country != null ) {
                newState.testcacheObject.countrycode = action.payload.country.value;
            } else {
                newState.testcacheObject.countrycode = "";
            }

            return newState;
        }

        case ACTIONS.TestcacheActionTypes.SET_SOURCE_TYPE: {
            let newState = _.cloneDeep(state);
            if ( action.payload.data_source_type != null ) {
                newState.testcacheObject.data_source_type = action.payload.data_source_type.value;
            } else {
                newState.testcacheObject.data_source_type = "";
            }

            return newState;
        }

        case ACTIONS.TestcacheActionTypes.GENERATE_POSTMAN_REQUEST: {
            let newState = _.cloneDeep(state);
            newState.postmanObject.address.addressLine1 = newState.testcacheObject.addressline1;
            newState.postmanObject.address.addressLine2 = newState.testcacheObject.addressline2;
            newState.postmanObject.address.addressLine3 = newState.testcacheObject.addressline3;
            newState.postmanObject.address.houseNumberAddition = newState.testcacheObject.housenumber;
            newState.postmanObject.address.thoroughfare = newState.testcacheObject.thoroughfare;
            newState.postmanObject.address.locality = newState.testcacheObject.locality;
            newState.postmanObject.address.postalCode = newState.testcacheObject.postalcode;
            newState.postmanObject.address.countryCode = newState.testcacheObject.countrycode;
            newState.postmanObject.identity.completename = newState.testcacheObject.completename;
            newState.postmanObject.identity.givenfullname = newState.testcacheObject.givenfullname;
            newState.postmanObject.identity.surname_first = newState.testcacheObject.surname_first;
            newState.postmanObject.identity.dob = newState.testcacheObject.dob;
            newState.postmanObject.identity.nationalid = newState.testcacheObject.nationalid;
            newState.postmanObject.phone.phone_number = newState.testcacheObject.phone;

            return newState;
        }

        case ACTIONS.apiActionsTestcache.DELETE_WARNING_FOR_TESTCACHE: {
            let newState = _.cloneDeep(state);
            newState.deleteTestcacheWarning = !newState.deleteTestcacheWarning;
            newState.testcacheIDForDelete = action.payload;

            return newState;
        }

        default:
            return state;
    }
}

export default addEditTestcacheReducer;
